import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Snowflake } from "lucide-react";

export default function HardinessZone({ location }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!location) return;
    setLoading(true);
    api
      .get(`/hardiness-zone?latitude=${location.latitude}&longitude=${location.longitude}`)
      .then((r) => setData(r.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [location]);

  if (!location) return null;

  return (
    <div className="sage-card p-6 relative" data-testid="hardiness-zone">
      <div className="label-overline mb-2">Hardiness zone</div>
      {loading || !data ? (
        <div className="h-8 w-20 bg-muted rounded animate-pulse" />
      ) : (
        <>
          <div className="flex items-baseline gap-3">
            <div className="font-serif text-5xl font-light text-primary">{data.zone}</div>
            <div className="text-xs text-muted-foreground">USDA</div>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-muted-foreground mt-2">
            <Snowflake className="w-3.5 h-3.5 text-accent" strokeWidth={1.4} />
            avg. low {Math.round(data.min_temp_f)}°F · {data.years_sampled}-year sample
          </div>
          <p className="text-xs text-foreground/70 mt-3 leading-relaxed">{data.description}</p>
        </>
      )}
    </div>
  );
}
